<template>
    <div class="video-details" style="position: sticky;
    top: 70px;
    z-index: 10;">
        <div class="video-details__frame">
            <vue-plyr ref="plyr" :options="options" v-if="renderAgain && plyrProcessed && lecture.streams && lecture.streams[0] && lecture.streams[0].stream_data.api === 'VISTREAM'">
                <video controls playsinline :src="plyrStreamData.stream.url" v-if="plyrStreamData.stream.type === 'DIRECT'">
                    <!--<source size="720" :src="plyrStreamData.stream.url" type="video/mp4"/>
                    <source size="480" :src="plyrStreamData.stream.url" type="video/mp4"/>-->
                </video>
                <video controls playsinline :src="plyrStreamData.stream.url" v-else-if="plyrStreamData.stream.type === 'HLS'">
                    <source size="720" :src="plyrStreamData.stream.url" type="application/x-mpegURL"/>
                </video>
            </vue-plyr>
            <!-- <VideoPlayer
              :options="videoPlayerDetails"
              v-if="
                videoPlayerDetails.loaded &&
                  lecture.streams &&
                  lecture.streams[0] &&
                  lecture.streams[0].stream_data.api === 'VISTREAM'
              "
            ></VideoPlayer> -->
            <div class="aspect-ratio-container" v-else>
                <iframe class="aspect-ratio-item" :src="streamUrl" :key="'video_iframe' + stream.stream_data.video_id" width="100%" height="500" frameborder="0" allow="autoplay; fullscreen" allowfullscreen id="videoIframe" v-if="streamUrl && stream.stream_data && stream.stream_data.api === 'VIMEO'">
                </iframe>
            </div>
        </div>

        <div class="video-details__header">
            <div class="lesson-watched-container pl-3 pr-2 py-2 mb-4">
                <div class="w-100">İzlenme durumu bazen otomatik algılanamayabilir. Bu dersi izlediyseniz ilerlemenizi kaydedebilirsiniz.</div>
                <button class="btn btn-sm btn-primary" @click="userWatchedBtn">İzledim</button>
            </div>
            <div class="feature-grid">
                <div class="feature-card">
                    <span class="ico">
                        <i class="icon-user"></i>
                    </span>

                    <span class="fw-600">
                        <small class="d-block">Öğretmen</small>
                        {{ stream.teacher && stream.teacher.full_name }}
                    </span>
                </div>

                <div class="feature-card">
                    <span class="ico">
                        <i class="icon-calendar"></i>
                    </span>

                    <span class="fw-600">
                        <small class="d-block">Ders Tarihi</small>
                        {{ stream.stream_date ? moment(stream.stream_date, 'YYYY-MM-DD HH:mm:ss').format('DD MMMM YYYY') : '-'}}
                    </span>
                </div>

                <div class="feature-card">
                    <span class="ico">
                        <i class="icon-time"></i>
                    </span>

                    <span class="fw-600">
                        <small class="d-block">Ders Süresi</small>
                        {{stream.stream_data && stream.stream_data.duration ? moment.utc(stream.stream_data.duration * 1000).format('HH [saat] mm [dk]') : '-'}}
                    </span>
                </div>
            </div>
        </div>
        <div class="video-details__footer">
            <!-- <details class="mb-3" >
                    <summary>Ders Hakkında</summary>
                    <p v-html="videoDetails.translate && videoDetails.translate.content"></p>
                  </details> -->
            <details>
                <summary>
                    Ödev Klasörü (Derse Özel)
                    <span class="badge badge-primary p-1 count-tabela ml-5">{{videoDetails.documents_count}}</span>
                </summary>
                <div class="row mt-3" v-if="videoDetails.documents">
                    <div class="col-md-4 mb-3" v-for="document in videoDetails.documents" :key="document.id">
                        <div class="video-source">
                            <div class="left fw-500">{{ document.name }}</div>
                            <div class="right">
                                <a target="__blank" :href="document.upload.public_url" class="btn btn-primary px-3">
                                    <i class="icon-download"></i>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="pt-10 pb-20" v-if="videoDetails.documents_count < 1">
                    <img width="220" src="@/assets/img/not-found-note.svg" alt=""/>
                </div>
            </details>
        </div>
    </div>
</template>
<script>
import EventBus from '../event-bus';
import Hls from 'hls.js';

export default {
    props: {
        videoDetails: Object,
        videoPlayerDetails: Object,
        lecture: Object,
        plyrStreamData: Object,
        plyrStreamDataLoaded: {default: false, type: Boolean},
    },
    data() {
        return {
            stream: this.lecture.streams[0],
            streamUrl: null,
            player: null,
            renderAgain: this.plyrStreamDataLoaded,
            plyrProcessed: false,
            plyrSelector: '',
            options: {
                autoplay: true,
                clickToPlay: true,
                controls: [
                    'progress',
                    'play-large',
                    'rewind',
                    'play',
                    'fast-forward',
                    'play',
                    'mute',
                    'volume',
                    'current-time',
                    'settings',
                    'pip',
                    'airplay',
                    'fullscreen',
                ],

                settings: ['quality', 'speed', 'loop'],
                seekTime: 7,
                tooltips: {controls: true, seek: true},
                speed: {selected: 1, options: [0.5, 0.75, 1, 1.10, 1.15, 1.25, 1.5, 1.75, 2]},

                i18n: {
                    rewind: 'Rewind {seektime} secs',
                    fastForward: 'Forward {seektime} secs',
                },
            },
            vimeoStatisticsInterval: null,
            syncDuration: null,
            videoCustomer: {
                interval: null,
                position: ['top-left', 'bottom-left', 'bottom-right', 'top-right', 'center'],
                counter: 0,
            },
            hlsInstance: {}
        };
    },
    created() {
        let scripts = ['//player.vimeo.com/api/player.js'];
        scripts.forEach((script) => {
            let tag = document.createElement('script');
            tag.setAttribute('src', script);
            document.body.appendChild(tag);
        });
    },
    mounted() {
        if (!this.isPlyrStream()) {
            return;
        }

        if (this.plyrStreamData.stream.type === 'HLS' && Hls.isSupported()) {
            const hls = new Hls();
            this.hlsInstance.hls = hls;
            hls.loadSource(this.plyrStreamData.stream.url);

            hls.once(Hls.Events.MANIFEST_PARSED, (event, data) => {
                const availableQualities = hls.levels.map((l) => l.height);

                this.options.quality = {
                    options: availableQualities,
                    // this ensures Plyr to use Hls to update quality level
                    forced: true,
                    onChange: (e) => this.updateQuality(e),
                };

                this.plyrProcessed = true;

                this.whenPlayerReady((player) => {
                    hls.attachMedia(player.media);
                    this.initPlayer(player);
                });
            });
        } else {
            this.plyrProcessed = true;
            this.whenPlayerReady((player) => this.initPlayer(player));
        }

        /*
        $(window).blur(() => {
            this.plyr.pause();
        });
        */
    },
    methods: {
        videoWatcher() {
            if (typeof Vimeo === 'undefined') {
                setTimeout(() => {
                    this.videoWatcher();
                }, 500);
                return false;
            }

            let videoIframe = document.getElementById('videoIframe');
            if (!videoIframe) {
                setTimeout(() => {
                    this.videoWatcher();
                }, 500);
                return false;
            }

            if (!(this.stream.stream_type === 'RECORD' && this.stream.stream_data && this.stream.stream_data.api === 'VIMEO')) {
                return false;
            }

            let player = new Vimeo.Player(videoIframe);
            if (this.stream && this.stream.user_watching_statistic && this.stream.user_watching_statistic.watching_complete != true && this.stream.user_watching_statistic.watching_duration) {
                player.setCurrentTime(
                    this.stream.user_watching_statistic.watching_duration,
                );
            }

            player.on('play', () => {
                if (this.vimeoStatisticsInterval) {
                    clearInterval(this.vimeoStatisticsInterval);
                }
                this.vimeoStatisticsInterval = setInterval(() => {
                    player.getCurrentTime().then((second) => {
                        this.syncDurationRequest(Math.floor(second));
                    })
                }, 15000); //30 * 1000
            });

            player.on('pause', () => {
                if (this.vimeoStatisticsInterval) {
                    clearInterval(this.vimeoStatisticsInterval);
                }
            });

            player.on('ended', (data) => {
                this.syncDurationRequest(Math.ceil(data.duration)).then(() =>{
                    EventBus.$emit('video_ended', this.stream);
                });
            });
        },
        updateQuality(newQuality) {
            if (!(this.hlsInstance.hls && this.hlsInstance.hls.levels)) {
                return false;
            }

            this.hlsInstance.hls.levels.forEach((level, levelIndex) => {
                if (level.height === newQuality) {
                    this.hlsInstance.hls.currentLevel = levelIndex;
                }
            });
        },

        isPlyrStream() {
            return !!(this.lecture.streams && this.lecture.streams[0] && this.lecture.streams[0].stream_data.api === 'VISTREAM');
        },

        getPlayer() {
            return this.$refs.plyr ? this.$refs.plyr.player : null;
        },

        // vue-plyr, Plyr örneğini kendi mounted adımında oluşturur. HLS'de bu, manifest
        // çözülene kadar gecikebilir; bu yüzden sabit bir süre beklemek yerine oynatıcı
        // gerçekten oluşana kadar bekliyoruz.
        whenPlayerReady(callback, attempt = 0) {
            this.$nextTick(() => {
                if (this.isDestroying) {
                    return;
                }

                const player = this.getPlayer();

                if (player) {
                    callback(player);
                    return;
                }

                if (attempt >= 100) {
                    console.warn('Video oynatıcı oluşturulamadı, izleme takibi başlatılamadı.');
                    return;
                }

                setTimeout(() => this.whenPlayerReady(callback, attempt + 1), 100);
            });
        },

        initPlayer(player) {
            if (this.plyrSelector) {
                return;
            }

            this.plyrSelector = player;

            this.plyrSelector.on('loadeddata', () => {
                this.resumeFromLastPosition();
            });

            if (player.media && player.media.readyState >= 2) {
                this.resumeFromLastPosition();
            }

            this.syncVideoDuration();

            if (this.plyrSelector.playing) {
                this.startSyncInterval();
            }

            this.plyrSelector.on('ended', () => {
                this.stopSyncInterval();
                this.syncDurationRequest(-1).then(() => {
                    EventBus.$emit('video_ended', this.stream);
                });
            });

            this.showCustomerInfo();
        },

        resumeFromLastPosition() {
            let statistic = this.stream.user_watching_statistic;
            this.setPlyrCurrentTime((statistic && statistic.watching_complete != true) ? statistic.watching_duration : 0);
        },

        getPlyrCurrentTime() {
            return this.plyrSelector.currentTime;
        },

        setPlyrCurrentTime(time) {
            this.plyrSelector.currentTime = time;
        },
        startSyncInterval() {
            this.stopSyncInterval();
            this.syncDuration = setInterval(() => {
                this.syncDurationRequest(Math.floor(this.getPlyrCurrentTime()));
            }, 15000);
        },
        stopSyncInterval() {
            if (this.syncDuration) {
                clearInterval(this.syncDuration);
                this.syncDuration = null;
            }
        },
        syncVideoDuration() {
            this.plyrSelector.on('play', () => this.startSyncInterval());
            this.plyrSelector.on('pause', () => this.stopSyncInterval());
        },
        syncDurationRequest(second){
            return this.axios.put(this.endpoints['lesson_stream_sync_duration'], {
                lecture_stream_id: this.stream.id,
                watching_duration: second,
            });
        },
        showCustomerInfo(){
            let wrapper = document.querySelector('.plyr__video-wrapper');

            if(wrapper) {
                wrapper.insertAdjacentHTML('beforeend',this.sprintf('<div class="customer-info top-left"><div>%s</div><div>%s</div></div>', [this.$root.user.full_name, this.$root.user.ip]));
            }

            this.videoCustomer.interval = setInterval(() => {
                let info = document.querySelector('.customer-info');
                if(info) {
                    let counter = this.videoCustomer.counter;
                    info.classList.remove(this.videoCustomer.position[counter]);

                    this.videoCustomer.counter = ((counter == (this.videoCustomer.position.length - 1)) ? 0 : (counter + 1));
                    info.classList.add(this.videoCustomer.position[this.videoCustomer.counter]);
                }
            }, 15000);
        },
        userWatchedBtn() {
            this.syncDurationRequest(-1).then(() =>{
                EventBus.$emit('video_ended', this.stream);
            });
        }
    },
    watch: {
        videoDetails(details) {
            this.streamUrl = null;
            setTimeout(() => {
                details.streams.forEach((item) => {
                    if (item.stream_type === 'RECORD') {
                        this.stream = item;
                        this.streamUrl = 'https://player.vimeo.com/video/' + this.stream.stream_data.video_id;
                        this.videoWatcher();
                    }
                });
            });
        },
        plyrStreamData: {
            handler: function (x, y) {
                this.renderAgain = true;
            },
            deep: true,
        },
    },
    beforeDestroy() {
        this.isDestroying = true;

        this.stopSyncInterval();

        // hls.js, Plyr'den önce kapatılmalı. Plyr kapanırken video öğesini sıfırlar ve
        // hls.js hâlâ bağlıysa sökülmüş tamponlara erişmeye çalışıp hata fırlatır.
        if (this.hlsInstance.hls) {
            try {
                this.hlsInstance.hls.detachMedia();
                this.hlsInstance.hls.destroy();
            } catch (e) {
                console.warn(e);
            }

            this.hlsInstance.hls = null;
        }

        const player = this.getPlayer();

        if (player) {
            try {
                player.destroy();
            } catch (e) {
                console.warn(e);
            }
        }

        if (this.vimeoStatisticsInterval) {
            clearInterval(this.vimeoStatisticsInterval);
        }

        if (this.videoCustomer.interval) {
            clearInterval(this.videoCustomer.interval);
        }
    },
};
</script>

<style>
.aspect-ratio-container {
    position: relative;
    height: 0;
    padding-top: 56%;
}

.aspect-ratio-item {
    position: absolute;
    left: 0;
    top: 0;
    width: 100% !important;
    height: 100% !important;
}

.plyr__controls {
    flex-wrap: wrap;
}

.plyr__progress__container {
    flex-basis: 100% !important;
}

.plyr__volume {
    margin-left: auto !important;
}

.customer-info {
    position: absolute;
    color: #b3b3b3;
    opacity: 0.5;
}

.customer-info.top-left {
    top: 15px;
    left: 15px;
}

.customer-info.bottom-left {
    bottom: 15px;
    left: 15px;
}

.customer-info.top-right {
    right: 15px;
    top: 15px;
}

.customer-info.bottom-right {
    right: 15px;
    bottom: 15px;
}

.customer-info.center {
    top: calc(50% - 25.5px);
    left: calc(50% - 46.5px);
}

.lesson-watched-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    background: rgba(var(--gray-soft--rgb), 0.05);
    border-radius: 12px;
}
</style>
